// plotPointOptions.js
export const plotPointOptions = {
    "Hero's Journey": [
        "Ordinary World: Introduce the protagonist in their regular life.",
        "Call to Adventure: The protagonist is faced with a problem or challenge.",
        "Refusal of the Call: The protagonist hesitates or refuses the challenge.",
        "Meeting the Mentor: The protagonist encounters a mentor who provides guidance.",
        "Crossing the Threshold: The protagonist commits to the adventure and leaves their ordinary world.",
        "Tests, Allies, and Enemies: The protagonist faces challenges and meets new allies and enemies.",
        "Approach to the Inmost Cave: The protagonist prepares for a major challenge in the new world.",
        "Ordeal: The protagonist faces a critical challenge, often a life-or-death situation.",
        "Reward (Seizing the Sword): The protagonist overcomes the challenge and gains a reward.",
        "The Road Back: The protagonist begins their return journey.",
        "Resurrection: The protagonist faces a final test, using what they've learned.",
        "Return with the Elixir: The protagonist returns to their ordinary world, transformed and with a reward."
    ],
    "Three-Act Structure": [
        "Opening Image: Introduce the setting and tone.",
        "Theme Stated: The underlying theme of the story is hinted at.",
        "Set-Up: Introduce main characters and their relationships.",
        "Catalyst (Inciting Incident): The event that sets the story in motion.",
        "Debate: The protagonist faces a dilemma.",
        "Break into Two: The protagonist commits to the journey.",
        "B Story: Introduction of a subplot, often a love interest.",
        "Fun and Games: The protagonist explores the new world.",
        "Midpoint: A major turning point, often a false victory or defeat.",
        "Bad Guys Close In: The protagonist faces increasing challenges.",
        "All Is Lost: The protagonist hits rock bottom.",
        "Dark Night of the Soul: The protagonist reflects and contemplates giving up.",
        "Break into Three: The protagonist finds a new resolve.",
        "Finale: The protagonist confronts the main challenge.",
        "Final Image: The resolution and transformation of the protagonist."
    ],
    "Character Arc Highlights": [
        "Introduction: Show the protagonist in their initial state.",
        "Inciting Incident: The event that disrupts the protagonist's life.",
        "First Turning Point: The protagonist makes a significant decision.",
        "Midpoint: The protagonist faces a major challenge that changes their perspective.",
        "Second Turning Point: The protagonist experiences a significant loss or revelation.",
        "Climax: The protagonist confronts the antagonist or main challenge.",
        "Resolution: The protagonist's new state after overcoming the challenge."
    ],
    "Sequence Breakdown": [
        "Sequence 1: Introduce the protagonist and their world.",
        "Sequence 2: The protagonist encounters the inciting incident.",
        "Sequence 3: The protagonist reacts to the inciting incident.",
        "Sequence 4: The protagonist makes a significant decision, leading to a major event.",
        "Sequence 5: The protagonist faces increasing obstacles.",
        "Sequence 6: The protagonist experiences a major setback.",
        "Sequence 7: The protagonist regroups and prepares for the final challenge.",
        "Sequence 8: The protagonist confronts the final challenge and the aftermath."
    ],
    "Simplified Plot Points": [
        "Ordinary World: Introduce the protagonist's regular life.",
        "Inciting Incident: The event that starts the story's main conflict.",
        "Rising Action: Series of events that build tension.",
        "Climax: The turning point or most intense moment.",
        "Falling Action: Events following the climax leading to resolution.",
        "Resolution: The story's conclusion and character transformation."
    ],
    "Plot Beats (Save the Cat!)": [
        "Opening Image",
        "Set-Up",
        "Theme Stated",
        "Catalyst",
        "Debate",
        "Break into Two",
        "B Story",
        "Fun and Games",
        "Midpoint",
        "Bad Guys Close In",
        "All Is Lost",
        "Dark Night of the Soul",
        "Break into Three",
        "Finale",
        "Final Image"
    ],
    "Scene-by-Scene Breakdown": [
        "Introduction",
        "Inciting Incident",
        "First Major Event",
        "Developing Conflict",
        "Midpoint",
        "Escalating Stakes",
        "All Is Lost Moment",
        "Climax",
        "Resolution"
    ]
};
